import EditSelect from './editSelect';
import { EditSelectProps as EditSelectCopyProps } from './interface';

export type EditSelectProps = EditSelectCopyProps;

export default EditSelect;
